import { Component } from '@angular/core';
import { ElementRef } from '@angular/core';
import { NavigationEnd } from '@angular/router';

import { Router } from '@angular/router';
import { OnInit } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(private elementRef:ElementRef, private router: Router) {
     this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
    };
  title = 'app';
  
  ngOnInit() {
    var s1 = document.createElement("script");
    s1.type = "text/javascript";
    s1.src = "../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s1);
    
}
  sendEvent = (type: string, cat: string) => {
    (<any>window).ga('send', 'event', {
      eventCategory: cat,
      eventLabel: type,
      eventAction: type,
      eventValue: 10
    });
  }
  sendmail(){
     console.log("In the app componenet for sending mail");
  }
}






// WEBPACK FOOTER //
// /Users/jacobvarghese/git/matchiq-web/matchiq/src/app/app.component.ts